import { render, staticRenderFns } from "./UserSection.vue?vue&type=template&id=4a891953"
import script from "./UserSection.vue?vue&type=script&lang=js"
export * from "./UserSection.vue?vue&type=script&lang=js"
import style0 from "./UserSection.vue?vue&type=style&index=0&id=4a891953&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports